var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO/Figma"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1732 50C19.3833 50 21.5029 49.1221 23.0657 47.5593C24.6285 45.9965 25.5065 43.8768 25.5065 41.6667V33.3334H17.1732C14.963 33.3334 12.8434 34.2113 11.2806 35.7742C9.71782 37.337 8.83984 39.4566 8.83984 41.6667C8.83984 43.8768 9.71782 45.9965 11.2806 47.5593C12.8434 49.1221 14.963 50 17.1732 50Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.83984 25C8.83984 22.7898 9.71782 20.6702 11.2806 19.1074C12.8434 17.5446 14.963 16.6666 17.1732 16.6666H25.5065V33.3333H17.1732C14.963 33.3333 12.8434 32.4553 11.2806 30.8925C9.71782 29.3297 8.83984 27.2101 8.83984 25Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.83984 8.33333C8.83984 6.12432 9.71692 4.00569 11.2783 2.44308C12.8397 0.880461 14.9577 0.00172579 17.1667 0L25.5 0V16.6667H17.1732C14.963 16.6667 12.8434 15.7887 11.2806 14.2259C9.71782 12.6631 8.83984 10.5435 8.83984 8.33333Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.5065 0H33.8398C36.0499 0 38.1696 0.877974 39.7324 2.44078C41.2952 4.00358 42.1731 6.1232 42.1731 8.33333C42.1731 10.5435 41.2952 12.6631 39.7324 14.2259C38.1696 15.7887 36.0499 16.6667 33.8398 16.6667H25.5065V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.1731 25C42.1731 27.2101 41.2952 29.3297 39.7324 30.8925C38.1696 32.4553 36.0499 33.3333 33.8398 33.3333C31.6297 33.3333 29.5101 32.4553 27.9472 30.8925C26.3844 29.3297 25.5065 27.2101 25.5065 25C25.5065 22.7898 26.3844 20.6702 27.9472 19.1074C29.5101 17.5446 31.6297 16.6666 33.8398 16.6666C36.0499 16.6666 38.1696 17.5446 39.7324 19.1074C41.2952 20.6702 42.1731 22.7898 42.1731 25Z",
    fill: "#1ABCFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.cd24339e133b63cbe2834fcf5b5be2ba.svg";
export { ForwardRef as ReactComponent };